<dx-form [formData]="justificationForm" id="form">
  <!-- elementAttr: { style: 'background-color: rgba(200,205,204,0); color: white;' }  -->
  <dxi-item dataField="day"
            caption="Giorno"
            editorType="dxDateBox"
            [label]="{ text: 'Giorno' }"
            [editorOptions]="{ disabled: false, readOnly: true, elementAttr: { style: 'background-color: white; color: black'} }">
    <dxi-validation-rule type="required"
                         message="Il giorno è obbligatorio">
    </dxi-validation-rule>
  </dxi-item>

  <dxi-item dataField="justification"
            editorType="dxSelectBox"
            caption="Giustificazione"
            [label]="{ text: 'Giustificazione' }"
            [editorOptions]="{
              items: justificationOptions,
              displayExpr: 'typeJustification',
              valueExpr: 'typeJustification',
              placeholder: 'Seleziona giustificazione'
            }">
    <dxi-validation-rule type="required"
                         message="La giustificazione è obbligatoria.">
    </dxi-validation-rule>
  </dxi-item>

  <dxi-item dataField="note"
            editorType="dxTextArea"
            [editorOptions]="{ height: 100 }">
    <dxi-validation-rule type="required"
                         message="Le note sono obbligatorie.">
    </dxi-validation-rule>
  </dxi-item>

  <dxi-item itemType="button" [buttonOptions]="registerButtonOptions">
  </dxi-item>
</dx-form>
